import React, { useState, useEffect } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { Ban, ShieldOff } from "lucide-react";
import { Switch } from "@/components/ui/switch";

export const SuspensionControl = ({ account, onChange }) => {
  const [suspended, setSuspended] = useState(!!account?.suspended);
  const [note, setNote] = useState(account?.suspension_note || "");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setSuspended(!!account?.suspended);
    setNote(account?.suspension_note || "");
  }, [account?.id, account?.suspended]);

  if (!account?.id) return null;

  const apply = async () => {
    setSaving(true);
    try {
      await api.put(`/admin/users/${account.id}/suspension`, { suspended, note });
      toast.success(suspended ? "Account suspended" : "Account reactivated");
      onChange && onChange();
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className={`card-soft ${suspended ? "border border-[#E63946]/40 bg-[#E63946]/5" : ""}`} data-testid="suspension-control">
      <h2 className="font-heading text-xl text-[#1E3F33] mb-3 flex items-center gap-2">
        <ShieldOff className="w-4 h-4 text-[#E63946]" /> Account access
      </h2>
      <div className="flex items-center justify-between py-1">
        <span className="text-sm text-[#1E3F33]">
          Suspend account
          {suspended && <span className="block text-[10px] mt-0.5 text-[#E63946]">No leads · login blocked</span>}
        </span>
        <Switch data-testid="suspension-switch" checked={suspended} onCheckedChange={setSuspended} />
      </div>
      <label className="label-soft mt-3">Audit note</label>
      <textarea data-testid="suspension-note" className="input-soft min-h-[60px]" placeholder="Reason (e.g., expired license, complaint)…" value={note} onChange={(e) => setNote(e.target.value)} />
      <button data-testid="suspension-apply" onClick={apply} disabled={saving} className="btn-primary text-xs py-2 mt-3 inline-flex items-center gap-2">
        <Ban className="w-3.5 h-3.5" /> {saving ? "Applying…" : "Apply"}
      </button>
      {account.suspended_at && suspended && <p className="text-[11px] text-[#8A9A86] mt-2">Suspended at {new Date(account.suspended_at).toLocaleString()}</p>}
    </div>
  );
};
